import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "grid-3 gap-sm" }
const _hoisted_2 = { class: "panel statistics-puff" }
const _hoisted_3 = { class: "panel statistics-puff" }
const _hoisted_4 = { class: "panel statistics-puff" }

import { onBeforeMount, ref } from 'vue';
import FaIcon from '@/core/components/FaIcon.vue';
import { useMe } from '@/modules/user/Me';
import { TicketStatistics } from '@/modules/ticket/Ticket';
import { useCustomer } from '@/modules/customer/Customer';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPartnerStatistics',
  setup(__props) {

const meResource = useMe();
const customerResource = useCustomer();
const ticketStatistics = ref<TicketStatistics>({
	unread: 0,
	ongoing: 0,
	done: 0,
});
const countCustomers = ref<number>(0);

onBeforeMount(async () => {
	ticketStatistics.value = await meResource.getPartnerTicketStatistics();
	countCustomers.value = await customerResource.getCount();
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createVNode(FaIcon, { icon: "users" }),
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" %{ count } st ", -1)
        ]))])), [
          [_directive_translate, {count: countCustomers.value}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("h3", null, [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Antal kunder", -1)
        ]))])), [
          [_directive_translate]
        ])
      ])
    ]),
    _createElementVNode("article", _hoisted_3, [
      _createVNode(FaIcon, { icon: "repeat" }),
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" %{ count } st ", -1)
        ]))])), [
          [_directive_translate, {count: ticketStatistics.value.ongoing}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("h3", null, [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Pågående ärenden", -1)
        ]))])), [
          [_directive_translate]
        ])
      ])
    ]),
    _createElementVNode("article", _hoisted_4, [
      _createVNode(FaIcon, { icon: "check-circle" }),
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" %{ count } st ", -1)
        ]))])), [
          [_directive_translate, {count: ticketStatistics.value.done}]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("h3", null, [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Avslutade ärenden", -1)
        ]))])), [
          [_directive_translate]
        ])
      ])
    ])
  ]))
}
}

})